module.exports = __webpack_public_path__ + "img/sparkly_btc.96021d90.svg";